/**
 * Zendure device action preparations
 */

import type {
	DeviceActionContext,
	PreparedDeviceAction,
} from 'src/components/Scenes/helpers/device_actions/types';

/**
 * Prepares action payload for Zendure devices.
 *
 * @param context - Context containing shared helpers and queued device actions.
 * @returns Prepared action payload ready for dispatch, or `null` when no supported action is present.
 */
export const prepareZendureAction = (context: DeviceActionContext): PreparedDeviceAction | null => {
	const { actions } = context;
	const deviceId = context.hexToDecimal; // For Zendure, we use the original device ID

	const action: PreparedDeviceAction = {
		_gui_purpose: 'action',
	};

	const output_limit = actions.find((el) => el.name === 'outputLimit');
	if (output_limit) {
		action.r = 'dev:' + deviceId + ':outputLimit';
		action.set = actions[0].value;
		return action;
	}

	return null;
};
